module.exports = "https://cdn2-fs.clearscore.com/flux/images/bfcb027eada4c8a2f395428b26bbc2df.jpg";